// Utils
import { getFrom } from '../getFrom';
/**
 * Returns a function that compares 2 values given a key|key path that exists in both JSON values and returns
 * either 1, 0 or -1
 *
 * @param {string} key A key path that should exist in both input values of the returned function
 * @returns {(a: Record<string, unknown>, b: Record<string, unknown>) => number} Comparison function
 */
export var objectCompareForSort = function (key) { return function (a, b) {
    var valueFromA = getFrom(a, key);
    var valueFromB = getFrom(b, key);
    if (valueFromA > valueFromB) {
        return 1;
    }
    return valueFromB > valueFromA ? -1 : 0;
}; };
//# sourceMappingURL=objectCompareForSort.js.map